import React from "react";

const LinkFound = ({ stroke = "#6C747A", fill = "#6C747A", ...props }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
      >
        <g clipPath="url(#clip0_178_2875)">
          <path
            d="M5.2278 11.5695H2.05695C1.47321 11.5695 1 11.0963 1 10.5125V2.05695C1 1.47321 1.47321 1 2.05695 1H5.31847C5.59879 1 5.86763 1.11136 6.06585 1.30957L7.03212 2.27585C7.23034 2.47407 7.49918 2.58542 7.7795 2.58542H11.041C11.6248 2.58542 12.098 3.05864 12.098 3.64237V5.2278"
            stroke={stroke}
            strokeLinecap="round"
          />
          <path
            d="M12.2627 13.7589L11.889 14.1326C10.8571 15.1645 9.18404 15.1645 8.15213 14.1326V14.1326C7.12022 13.1007 7.12021 11.4276 8.15212 10.3957L8.52581 10.022M10.0206 8.52728L10.3943 8.15359C11.4262 7.12168 13.0992 7.12169 14.1311 8.1536V8.1536C15.163 9.18551 15.163 10.8586 14.1311 11.8905L13.7574 12.2642M11.889 10.3957L10.3943 11.8905"
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_178_2875">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default LinkFound;
